import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100/60 border-y hairline">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-4">
          <span className="text-xs md:text-sm tracking-[0.3em] text-accent-700 uppercase">
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            关于今日更新，你可能想问
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            追新料之前，先把更新节奏和可信度标准说清楚，
            这样你看到每一条的时候都知道该怎么判断。
          </p>
          <div className="mt-6 inline-flex items-center gap-3 rounded-lg border hairline bg-background-50 px-4 py-3">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-soft" />
            <span className="text-sm text-foreground-700">
              仍有疑问？首页底部可查看完整说明
            </span>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="rounded-lg border hairline bg-background-50 overflow-hidden divide-y divide-foreground-950/8">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={faq.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="w-full flex items-center gap-4 text-left px-5 md:px-7 py-5 cursor-pointer hover:bg-background-100/60 transition-colors"
                  >
                    <span className="font-heading text-sm md:text-base font-bold text-foreground-950 flex-1">
                      {faq.q}
                    </span>
                    <span
                      className={`w-8 h-8 rounded-full border hairline flex items-center justify-center shrink-0 transition-transform duration-300 ${
                        isOpen ? "rotate-45 bg-primary-500 text-background-50 border-transparent" : "text-foreground-600"
                      }`}
                    >
                      <i className="ri-add-line text-lg" />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 md:px-7 pb-5 -mt-1">
                      <p className="text-sm md:text-base leading-relaxed text-foreground-600 pl-0 md:pl-1">
                        {faq.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}